import { ComponentProps } from 'react';
import { HStack } from 'native-base';

import { Text } from '@pimm/base';
import { CalendarEvent } from '../context/calendar-events-context';

type EmployeeEventBadgeProps = ComponentProps<typeof HStack> & {
  date: Date;
  event: CalendarEvent;
};

export const EmployeeEventBadge = ({ date, event, ...props }: EmployeeEventBadgeProps) => {
  return (
    <HStack
      space={2}
      alignItems="center"
      px={1.5}
      minHeight="25px"
      bgColor="white"
      rounded="md"
      borderWidth={1}
      borderColor="gray.300"
      alignSelf="flex-start"
      {...props}
    >
      <Text size="md" fontWeight={600} color="black" lineHeight="xs" numberOfLines={1}>
        {event.name ?? ''}
      </Text>
      {event.type === 'Anniversary' && (
        <Text size="md" color="black" fontWeight={500}>
          {`${date.getFullYear() - event.dateTime.getFullYear()}y`}
        </Text>
      )}
    </HStack>
  );
};
